import { Injectable, inject } from '@angular/core';
import { DeactivatedClientBaseGuard } from './deactivated-client-base-guard';
import { Router } from '@angular/router';
import { ClientsService } from 'app/core/services/clients.service';

@Injectable()
export class DeactivatedClientCePortalTasksGuard extends DeactivatedClientBaseGuard {
  protected clientService: ClientsService;
  protected router: Router;

  constructor() {
    const clientService = inject(ClientsService);
    const router = inject(Router);

    super('/ce-portal/tasks/deactivated', clientService, router);

    this.clientService = clientService;
    this.router = router;
  }
}
